import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import "./msgs/ClientMsgReceiver";
import { requestFailoverStatus, requestFailoverConfig } from "./msgs/MsgSender";
import failoverStore, { FailoverContext } from "./failoverStore";

interface IProps {
    appID?: string;
    children: ReactNode;
}

function FailoverProvider(props: IProps) {
    useEffect(() => {
        requestFailoverStatus();
        requestFailoverConfig();
        setInterval(() => {
            try {
                requestFailoverStatus();
            } catch (_) {}
        }, 30000);
    }, []);

    return (
        <Provider store={failoverStore} context={FailoverContext}>
            {props.children}
        </Provider>
    );
}

export default FailoverProvider;
